import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import _capitalize from 'lodash/capitalize';

import BaseOption from '../Option';

const rootStyles = {display: 'flex', alignItems: 'center', overflow: 'hidden'};
const avatarStyles = {height: 34, width: 34};
const listItemTextStyles = {
  primary: {fontSize: '0.84rem', lineHeight: 1.2, margin: '3px 0', display: 'flex'},
  secondary: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '0.74rem',
    lineHeight: 1,
    marginBottom: 3,
  },
};

const UserAvatarOption = (props) => {
  const {selectProps, innerProps} = props;
  const {virtualized} = selectProps;

  if (virtualized) {
    delete innerProps.onMouseMove;
    delete innerProps.onMouseOver;
  }
  return (
    <BaseOption {...props}>
      <div title={props.data.name} style={rootStyles}>
        <Avatar alt={props.data.name} src={props.data.picture} style={avatarStyles} />

        <ListItemText
          primary={<span style={listItemTextStyles.primary}>{props.data.name}</span>}
          secondary={<span style={listItemTextStyles.secondary}>{props.data.email}</span>}
        />
      </div>
    </BaseOption>
  );
};

export default UserAvatarOption;
